import React from "react";
import {
  Box,
  Card,
  CardMedia,
  Typography,
  Divider,
  Button,
  IconButton,
  Stack,
  Paper,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";


const PostBankcard = () => {
    const navigate = useNavigate();

  return (
    <Box
      sx={{
        maxWidth: 420,
        mx: "auto",
        p: 2,
        bgcolor: "#f0f0f0",
      }}
    >
      <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden" }}>
        {/* Header */}

<Box p={2} bgcolor="#1a1a1a" color="white">
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    
    {/* Back Button + Title */}
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton
        size="small"
        onClick={() => navigate(-1)}
        sx={{ color: "white" }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Typography fontWeight={600}>Auction Property</Typography>
    </Stack>

    {/* ID & Date */}
    <Box textAlign="right">
      <Typography fontSize={11}>ID: 12534</Typography>
      <Typography fontSize={11}>Date: 26-11-2025</Typography>
    </Box>
  </Stack>
</Box>


        {/* Image */}
        <Box position="relative">
          <CardMedia
            component="img"
            height="230"
            image="/building_postbank-card.png" 
            alt="property"
          />
          <Stack
            direction="row"
            spacing={1}
            sx={{ position: "absolute", top: 10, right: 10 }}
          >
            <IconButton size="small" sx={{ bgcolor: "white", color:'blue' }}>
              <ShareIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" sx={{ bgcolor: "white", color:'red' }}>
              <FavoriteBorderIcon fontSize="small" color="error" />
            </IconButton>
          </Stack>
        </Box>

        {/* Reserve Price Box */}
        <Box p={2}>
          <Box
            sx={{
              bgcolor: "#ffeaea",
              borderRadius: 2,
              p: 1,
              mb: 2,
              borderLeft: "4px solid #ff6b6b",
            }}
          >
            <Typography fontSize={12} color="gray">
              Reserve Price
            </Typography>
            <Typography fontSize={20} fontWeight={700} color="#ff4d4d">
              ₹31,32,000
            </Typography>
          </Box>

          {/* Property Details */}
          <Typography fontSize={13} fontWeight={600}>
            Property type:{" "}
            <span style={{ fontWeight: 400 }}>Commercial Building</span>
          </Typography>

          <Typography mt={1} fontSize={13} fontWeight={600}>
            City/Town:{" "}
            <span style={{ fontWeight: 400 }}>
              Yeswanthpura, Bangalore
            </span>
          </Typography>

          <Stack direction="row" mt={1} spacing={1} alignItems="center">
            <LocationOnIcon fontSize="small" color="primary" />
            <Typography fontSize={13}>Location</Typography>
          </Stack>

          <Typography mt={1} fontSize={13}>
            <strong>Area:</strong> 900 sq.ft.
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Info Table */}
          <Box>
            {[
              ["EMD Amount:", "₹3,13,200"],
              ["Bid Increment:", "₹10,000"],
              ["EMD Submission:", "Thu, 27 Nov 2025 12:00 AM"],
              ["Auction Start:", "Fri, 28 Nov 2025 02:00 PM"],
              ["Auction End:", "Fri, 28 Nov 2025 03:00 PM"],
              ["Possession:", "Symbolic/Physical"],
            ].map(([label, value], i) => (
              <Stack
                key={i}
                direction="row"
                justifyContent="space-between"
                sx={{ mb: 1 }}
              >
                <Typography fontSize={13}>{label}</Typography>
                <Typography fontSize={13} fontWeight={600}>
                  {value}
                </Typography>
              </Stack>
            ))}
          </Box>

          <Button
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              borderRadius: 2,
              textTransform: "none",
              bgcolor: "#2d2d2d",
            }}
          >
            Download Auction File
          </Button>

          {/* Bank Info Box */}
          <Box
            mt={3}
            p={2}
            sx={{
              border: "1px solid #ddd",
              borderRadius: 2,
              bgcolor: "#fafafa",
            }}
          >
            <Typography fontWeight={600}>
              State Bank of India
            </Typography>
            <Typography mt={0.5} color="gray" fontSize={13}>
              Contact: xxxxxxxxx125
            </Typography>

            <Button
              variant="outlined"
              startIcon={<CallIcon />}
              sx={{
                mt: -5,
                borderRadius: 2,
                textTransform: "none",
                float: "right",
              }}
            >
              Call
            </Button>
          </Box>

          {/* Description */}
          <Box mt={3}>
            <Typography mb={1} fontWeight={600}>
              Description
            </Typography>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: 2,
                height: 120,
                p: 1,
              }}
            />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default PostBankcard;
